<template>
  <div>
    <DefaultNotification
      v-if="isOpen"
      @update-card="updateCard"
      @openCard="$emit('openCard', $event)"
      @close-notification="closeNotification"
      @toggle-order="toggleOrder"
      @toggle-all="toggleAll"
      :title="notification.title"
      :expand-text="notification.expandText"
      :notificationSwitch="false"
      :doubleSwitchText="['Responsável', 'Oportunidade']"
      :cards="cards"
      :viewedCards="viewedCards"
    />
  </div>
</template>

<script>
import NotificationsCardRepository from '@/shared/http/repositories/crm/notificationscard.js'
import moment from 'moment'
import DefaultNotification from './NotificacaoPadrao.vue'

export default {
  components: {
    DefaultNotification
  },
  data () {
    return {
      notification: {
        title: 'Notificações',
        expandText: 'Visualizados'
      },
      cards: [],
      viewedCards: [],
      data: [],
      isOpen: true,
      asc: true,
      fromBoardColumn: false
    }
  },
  mounted () {
    this.retrieveNotifications()
  },
  methods: {
    closeNotification () {
      this.isOpen = false
    },
    formatDate (value) {
      if (value) {
        return moment(value).fromNow()
      }
      return null
    },
    retrieveNotifications () {
      this.getViewed()
      this.getNotViewed()
    },
    getViewed () {
      this.viewedCards = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `fromBoardColumn=${this.fromBoardColumn}&visualizado=true&sort=dataNotificiacao,${order}`
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then((response) => {
          if (response.data) {
            this.data = response.data.content
            this.viewedCards = this.data.map((element) => ({
              cardIcon: element.fromBoardColumn
                ? 'fas fa-bell'
                : 'fas fa-lightbulb',
              cardIconText: this.formatDate(element.dataNotificiacao),
              cardPersonPic: '',
              cardTitle: element.card.nomePessoa,
              cardDescription: element.card.boardColumn.board.nome
                ? element.card.boardColumn.board.nome
                : element.card.boardColumn.nome,
              cardChecked: element.visualizado,
              cardObj: element
            }))
          }
        })
        .catch(this.onException)
    },
    getNotViewed () {
      this.cards = []
      let order = this.asc ? 'asc' : 'desc'
      let params = `fromBoardColumn=${this.fromBoardColumn}&visualizado=false&sort=dataNotificiacao,${order}`
      NotificationsCardRepository.searchNotificationsUserCustom(params)
        .then((response) => {
          if (response.data) {
            this.data = response.data.content
            this.cards = this.data.map((element) => ({
              cardIcon: element.fromBoardColumn
                ? 'fas fa-bell'
                : 'fas fa-lightbulb',
              cardIconText: this.formatDate(element.dataNotificiacao),
              cardPersonPic: '',
              cardTitle: element.card.nomePessoa,
              cardDescription: element.card.boardColumn.board.nome
                ? element.card.boardColumn.board.nome
                : element.card.boardColumn.nome,
              cardChecked: element.visualizado,
              cardObj: element
            }))
          }
        })
        .catch(this.onException)
    },
    updateCard (card) {
      this.retrieveNotifications()
    },
    toggleOrder () {
      this.asc = !this.asc
      this.retrieveNotifications()
    },
    toggleAll () {
      this.fromBoardColumn = !this.fromBoardColumn
      this.retrieveNotifications()
    }
  },
  emits: ['update-card', 'close-notification', 'toggle-all', 'toogle-order']
}
</script>



// WEBPACK FOOTER //
// src/components/UI/notificacao/Oportunidades.vue